import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Post } from '../services/http';
import { validateForm } from '../services/validate';
import UploadImage from '../services/upload-image';
import './dialog.css';

export default function UtmLink() {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState(null);
    const [partnerLink, setPartnerLink] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
           
            <a onClick={handleClickOpen} class="social__link social__link--mail" style={{ background: '#0078B9' }}>
                                        {/* <InsertLinkIcon style={{ color: 'white', fontSize: '22px' }} /> */}
                                        <img src="/img/sprite/link.png" alt="" />
                                    </a>
            <div id="popup-login" className={open ? 'popup _open' : 'popup'}>
                <div class="popup__body">
                    <div class="popup__content" style={{ position: 'relative', background: '#FAFAFA' }}>
                        <div class="login-form">
                            <h3 class="color-1 rubik weight-600 f-24">Create a UTM link</h3>
                            <hr style={{ border: '1px solid', color: 'rgba(21, 121, 190, 1)' }} />
                            <p class="remove-margin-bottom" onClick={handleClose} style={{ cursor: 'pointer', color: 'red', position: 'absolute', top: 10, right: 10 }}><CloseIcon style={{ fontSize: '30px' }} /></p>
                            {/* <div class="center-text-and-line"> */}
                            <div class="form-button">
                                <p className="rubik weight-400 f-22 f-mobile mb-0" style={{ color: "#000000" }}>worldoftzedaka.org.canpaign/84?eff=
                                    <span><input className="rubik weight-400 f-22 f-mobile" style={{ width: '150px', border: '1px solid #000000', boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.04)', borderRadius: '8px', padding: '10px' }} type="text" /></span>
                                </p>
                                <p className="mt-20 rubik weight-400 f-22 f-mobile mb-0" style={{ color: "#000000" }}>
                                    Add a note <span><input className="rubik weight-400 f-22 f-mobile" style={{ width: '80%', border: '1px solid #000000', boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.04)', borderRadius: '8px', padding: '10px' }} type="text" /></span>
                                </p>
                            </div>
                            <div className="text-center" style={{ marginTop: '40px', marginBottom: '20px' }}>
                                    <a  
                                    style={{ cursor: 'pointer',
                                    fontSize:'20px',
                                    fontFamily:'Rubik',

                                     textDecoration: 'none', backGround:'#1979BE', fontWeight: '500', paddingLeft: '80px', paddingRight: '80px', paddingTop: '15px', paddingBottom: '15px' }} 
                                    className="login_button"> <span> 
                                 </span>  save and copy link</a>
                                   
                                </div>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
